import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IStandardDescriptionsService } from "services/StandardDescriptionsService";
import { StandardDescriptionModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  StandardDescriptions: new Array<StandardDescriptionModel>(),
  Loading: false,
};

export const standardDescriptionsSlice = createSlice({
  name: "standardDescriptions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStandardDescriptions.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getStandardDescriptions.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getStandardDescriptions.fulfilled, (state, action) => {
        state.StandardDescriptions = action.payload;
        state.Loading = false;
      });
  },
});

export const getStandardDescriptions = createAsyncThunk("StandardDescriptions/GetStandardDescriptions", async () => {
  const standardDescriptionsService = container.get<IStandardDescriptionsService>(
    SERVICE_TYPES.StandardDescriptionsService
  );
  return await standardDescriptionsService.getStandardDescriptions();
});

export const selectStandardDescriptions = (state: RootState) => {
  return state.standardDescriptions.StandardDescriptions;
};
export const selectLoading = (state: RootState) => {
  return state.standardDescriptions.Loading;
};

export default standardDescriptionsSlice.reducer;
